// src/graphql/customQueries.js
export const projectMembersByProjectLite = /* GraphQL */ `
  query ProjectMembersByProjectLite($projectId: ID!, $limit: Int, $nextToken: String) {
    projectMembersByProject(projectId: $projectId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectId
        userId
        role
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const projectMembersByProjectWithUser = /* GraphQL */ `
  query ProjectMembersByProject($projectId: ID!, $limit: Int, $nextToken: String) {
    projectMembersByProject(projectId: $projectId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectId
        userId
        role
        user {
          id
          name
        }
      }
      nextToken
    }
  }
`;

export const classifiedDocumentsByProjectBuildingCode = /* GraphQL */ `
  query ClassifiedDocumentsByProjectBuildingCode($projectId: ID!, $complianceType: String, $limit: Int, $nextToken: String) {
    classifiedDocumentsByProject(projectId: $projectId, complianceType: $complianceType, limit: $limit, nextToken: $nextToken) {
      items {
        id
        complianceType
      }
      nextToken
    }
  }
`;

/** Project fields for settings / multi-entity setup (avoids bloated generated getProject). */
export const getProjectSettingsBundle = /* GraphQL */ `
  query GetProjectSettingsBundle($id: ID!) {
    getProject(id: $id) {
      id
      name
      description
      location
      type
      phase
      status
      companyId
      zoningDesignation
      buildingClassification
      occupancyRegion
      occupancyTypes
      occupancyCodes
      majorOccupancy
      buildingFootprintArea
      buildingFootprintAreaExisting
      buildingFootprintAreaProposed
      grossFloorAreaExisting
      grossFloorAreaProposed
      siteArea
      grossFloorArea
      storeysAboveGrade
      storeysBelowGrade
      averageGrade
      adjacentStreets
      roughConstructionBudget
      constructionType
      buildingHeight
      highBuilding
      sprinklerSystem
      fireAlarm
      standpipe
      hazardousSubstances
      startDate
      estimatedCompletion
      projectCategory
      entitiesData
    }
  }
`;

export const updateProjectDescriptionFallback = /* GraphQL */ `
  mutation UpdateProjectDescriptionFallback($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      description
      updatedAt
    }
  }
`;

export const updateProjectSettingsBundle = /* GraphQL */ `
  mutation UpdateProjectSettingsBundle($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      projectCategory
      entitiesData
      name
      buildingClassification
      constructionType
      description
      updatedAt
    }
  }
`;

export const classifiedDocumentsByProjectWithTags = /* GraphQL */ `
  query ClassifiedDocumentsByProjectWithTags($projectId: ID!, $limit: Int, $nextToken: String) {
    classifiedDocumentsByProject(projectId: $projectId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fileName
        category
        complianceType
        projectBuildingDataIds
        updatedAt
      }
      nextToken
    }
  }
`;

export const updateClassifiedDocumentTags = /* GraphQL */ `
  mutation UpdateClassifiedDocumentTags($input: UpdateClassifiedDocumentInput!) {
    updateClassifiedDocument(input: $input) {
      id
      projectBuildingDataIds
      updatedAt
    }
  }
`;


export const getProjectLite = /* GraphQL */ `
  query GetProjectLite($id: ID!) {
    getProject(id: $id) {
      id
      name
      type
      phase
      status
      location
      description
      zoningDesignation
      occupancyRegion
      occupancyTypes
      occupancyCodes
      majorOccupancy
      buildingClassification
      constructionType
      adjacentStreets
      averageGrade
      buildingFootprintArea
      buildingFootprintAreaExisting
      buildingFootprintAreaProposed
      grossFloorAreaExisting
      grossFloorAreaProposed
      grossFloorArea
      siteArea
      storeysAboveGrade
      storeysBelowGrade
      buildingHeight
      highBuilding
      sprinklerSystem
      fireAlarm
      standpipe
      hazardousSubstances
      roughConstructionBudget
      startDate
      estimatedCompletion
      lastModified
      createdAt
      updatedAt
      companyId
      owner
      projectCategory
      entitiesData
      hasBuildingCodeExtractions
      __typename
    }
  }
`;